import config from '@/config';
import taskMessages from '@/modules/tasks/taskMessages';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { TaskQueryKey } from './queryKey';
export var useDeletePlannedTask = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (values) {
        return api.base
            .delete("".concat(config.appUrls.tasks, "/api/plannedTasks/").concat(values.taskId), {
            params: { taskLevel: values.taskLevel },
        })
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries([TaskQueryKey.PlannedTasks]);
            ToastrService.success(intl.formatMessage(taskMessages.TaskDeleted));
        },
        onError: function (e) {
            handleHttpError(intl)(e);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        deletePlannedTask: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
